module.exports = __webpack_public_path__ + "static/media/rnds_contra_chave.183bd6ce.png";